module.exports = "https://cdn.realtymogul.com/static/media/logo_stacked_white.3115f7df.svg";